import React, { useMemo } from 'react';

import { isThankYouLotto } from '../../../../utils/template';

import FirstAndLastBalls from './FirstAndLastBalls';

import { LotteryDrawRecord } from 'Api/SiteApi/Responses';
import { LA_PRIMITIVA } from 'utils/LotterySlugs';

export const BALL_INDICATORS = {
    [LA_PRIMITIVA]: {
        1: 'C',
        2: 'R',
    },
};

export const hasBallIndicator = (lotterySlug: string, rangeIndex: number) => {
    return BALL_INDICATORS?.[lotterySlug]?.[rangeIndex] !== undefined;
};

export const getBallIndicator = (lotterySlug: string, rangeIndex: number) => {
    return BALL_INDICATORS?.[lotterySlug]?.[rangeIndex];
};

export function addBallIndicatorIfNeeded(lotterySlug: string, rangeIndex: number) {
    return (
        hasBallIndicator(lotterySlug, rangeIndex) && (
            <div className="ball-indicator">{getBallIndicator(lotterySlug, rangeIndex)}</div>
        )
    );
}

export function ensureNumberArray(numbers: number | number[]): number[] {
    return Array.isArray(numbers) ? numbers : [numbers];
}

type Props = Readonly<{
    lotteryDraw: LotteryDrawRecord;
    lotterySlug: string;
    usePrimaryBall: boolean;
}>;

function Balls({ lotteryDraw, lotterySlug, usePrimaryBall = false }: Props) {
    const isTemplateThankYouLotto = useMemo(() => isThankYouLotto(), []);

    if (lotteryDraw.hasFirstAndLastNumbers) {
        return <FirstAndLastBalls numbers={ensureNumberArray(lotteryDraw.numbers[0])} />;
    }

    return (
        <div className={isTemplateThankYouLotto ? 'd-flex gap-2' : 'row font-black row-balls'}>
            {lotteryDraw.numbers.map((range, rangeIndex) =>
                ensureNumberArray(range).map((number, numberIndex) => {
                    const isBonusNumber = rangeIndex >= 1 ? 1 : rangeIndex;

                    let ballClass: string;
                    if (isTemplateThankYouLotto) {
                        ballClass = usePrimaryBall ? 'lotto-star' : 'lotto-ball bg-info';
                    } else {
                        ballClass = `results-ball ball-bg ball-main ball-${usePrimaryBall ? 0 : isBonusNumber}`;
                    }

                    return (
                        <div key={`${rangeIndex}-${numberIndex}`} className={ballClass}>
                            {number}
                            {addBallIndicatorIfNeeded(lotterySlug, rangeIndex)}
                        </div>
                    );
                })
            )}
        </div>
    );
}

export default Balls;
